import React from 'react';
import { useScrollAnimation } from '../../hooks/useScrollAnimation';
import BackToTop from '../../components/BackToTop/BackToTop';
import './Contact.css';

const Contact = () => {
  useScrollAnimation();

  return (
    <div className="contact-page">
      {/* Page Content */}
      <section className="page-content">
        <div className="container">
          <h1 className="page-title">Contact Us</h1>            
          <div className="professional-contact">
            <div className="content-wrapper">
              <p className="page-intro">Trimline strives to provide the best service possible with every contact! We operate in a business built on trust. This can only be achieved through communication and experienced support from the first contact past your ten-year anniversary.</p>
              
              <div className="contact-cards">
                <div className="contact-card">
                  <div className="contact-icon">
                    <i className="fas fa-map-marker-alt"></i>
                  </div>
                  <h3>Our Global Locations</h3>
                  <p>With offices across the globe, we're positioned to serve you wherever you are.</p>
                  
                  <div className="address-container">
                    <div className="address-section">
                      <h4>USA Offices</h4>
                      <div className="address-line">
                        <i className="fas fa-building"></i>
                        <div className="address-text">Trimline Group LLC, WY 82801 USA</div>
                      </div>
                      <div className="address-line">
                        <i className="fas fa-building"></i>
                        <div className="address-text">Trimline International LLC Sheridan, WY 82801 USA</div>
                      </div>
                    </div>
                    
                    <div className="address-section">
                      <h4>International Offices</h4>
                      <div className="address-line">
                        <i className="fas fa-globe"></i>
                        <div className="address-text">Trimline Group, 10th Floor, Horizon Tower, Com 2/6, Khayaban-e-Saadi, Block 3 Clifton, Karachi, Pakistan</div>
                      </div>
                      <div className="address-line">
                        <i className="fas fa-globe"></i>
                        <div className="address-text">Trimline International LLC, Shams Business Center, Al Messaned, Sharjah, UAE</div>
                      </div>
                      <div className="address-line">
                        <i className="fas fa-globe"></i>
                        <div className="address-text">TL Khazanay, 8th Zamzama Blvd, Zamzama Commercial Area Defence V Karachi, Pakistan</div>
                      </div>
                      <div className="address-line">
                        <i className="fas fa-globe"></i>
                        <div className="address-text">Trimline Commodities, 1st Floor, Plot MR 5/143, Zakariya lane, Virjee Street, Jodia Bazar, Karachi</div>
                      </div>
                    </div>
                  </div>
                </div>
                
                <div className="contact-card">
                  <div className="contact-icon">
                    <i className="fas fa-envelope"></i>
                  </div>
                  <h3>Email Us</h3>
                  <p>For all inquiries, partnership opportunities, or general information:</p>
                  <p><a href="mailto:info@trimlineco.com">info@trimlineco.com</a></p>
                  <p><a href="mailto:info@trimlinepolymers.com">info@trimlinepolymers.com</a></p>
                  <p><a href="mailto:info@jytholdings.com">info@jytholdings.com</a></p>
                  <p><a href="mailto:sales@jadechemi.com">sales@jadechemi.com</a></p>
                  <p><a href="mailto:cs@khazanay.pk">cs@khazanay.pk</a></p>

                  <p>We typically respond to all emails within 24 hours during business days.</p>
                </div>
                
                <div className="contact-card centered-card">
                  <div className="contact-icon">
                    <i className="fas fa-phone-alt"></i>
                  </div>
                  <h3>Call Us Directly</h3>
                  <p>Speak with our team during business hours:</p>
                  <p className="phone-number">+1-646-980-4849</p>
                  <p className="phone-number">+971-58-906-2082</p>
                  <p className="phone-number">+92-321-2427964</p>
                  <p>Our dedicated team is available Monday through Saturday to assist you.</p>
                </div>
              </div>
              
              <div className="map-section">
                <div className="map-placeholder">
                  <i className="fas fa-map-marked-alt"></i>
                  <p>With a global presence across multiple continents, Trimline Group is strategically positioned to serve clients worldwide with efficiency and local expertise.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <BackToTop />
    </div>
  );
};

export default Contact;